export default {
  // AlternativeNamesView
  alternativeNames: 'Alternative Names',

  // AlternativeNames
  editAlternativeName: 'Edit alternative name',
  defaultSingularName: 'Default singular name',
  defaultPluralName: 'Default plural name',
  abbreviatedName: 'Abbreviated name',
  singularArticle: 'Singular article',
  singularName: 'Singular name',
  pluralArticle: 'Plural article',
  pluralName: 'Plural name',

  // AlternativeNameForm
  selectArticle: 'Select an article',
  mustSelectArticle: 'You must select an article.',
  deleteAlternativeNameConfirmation: 'Are you sure you want to delete it?',
  updated: 'Updated',
}
